export const CHECKOUT_RENEWAL_ERROR_MESSAGES: Record<string, string> = {
  unauthorized:
    "Os dígitos informados não conferem com o CPF, verifique os dados e tente novamente.",
  invalid_hash:
    "O link de renovação é inválido ou expirou. Solicite um novo link e tente novamente.",
  subscription_active: "Esta assinatura já está ativa e não pode ser renovada por este link.",
};

export const CHECKOUT_RENEWAL_DEFAULT_ERROR_MESSAGE =
  "Erro ao realizar renovação, verifique os dados e tente novamente.";
